
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommRefundGrid extends Serenity.EntityGrid<ECommRefundRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommRefund'; }
        protected getDialogType() { return ECommRefundDialog; }
        protected getIdProperty() { return ECommRefundRow.idProperty; }
        protected getInsertPermission() { return ECommRefundRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommRefundRow.localTextPrefix; }
        protected getService() { return ECommRefundService.baseUrl; }


        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date(); 

            var voucherNo = FormatHelper.GetVoucherNo(85);

            this.editItem(<ECommRefundRow>{
                VoucherNo: voucherNo,
                VoucherTypeId: 85,
                CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                TransDate: now.toDateString()
            });
        }
    }
}